import useResourceList from './useResourceList';
import mutationFactory from './mutationFactory';

import api from '..';

export const useGettyImagesList = (queryVariables = {}, queryConfig = {}) => {
  const queryResult = useResourceList({ name: 'getty-images', api: api.gettyImages }, queryVariables, queryConfig);

  return {
    gettyImagesList: queryResult.resolvedData.data || [],
    ...queryResult,
  };
};

const createMutation = mutationFactory({ invalidate: 'getty-images' });

export const usePublishGettyImage = createMutation(api.gettyImages.publish);

export const useDeleteGettyImage = createMutation(api.gettyImages.remove);
